<div class="section" [formGroup]="professionalDetailsForm">
  <p class="section__title">Welcome {{ userName }}!</p>
  <div class="section__item">
    <div class="row">
      <div class="col-5">
        <p class="xen-heading-4 mb-0">Please confirm your company’s trading name</p>
        <p class="section__item-subtit">This helps us provide the best possible service</p>
      </div>
      <div class="col-7">
        <xen-input
          [label]="'Company’s trading name'"
          [formControlName]="'companyName'"
          [required]="true"
          [type]="'text'"
          [placeholder]="'Company name'"
          [size]="'medium'"
          [validation]="true"
          [validation_status]="getValidationStatus('companyName', true)"
          [feedback]="
            professionalDetailsForm.get('companyName').dirty
              ? $safeNavigationMigration(professionalDetailsForm.get('companyName').errors?.errorMsg)
              : ''
          "
        ></xen-input>
      </div>
    </div>
  </div>
  <div class="section__item">
    <div class="row">
      <div class="col-5">
        <p class="xen-heading-4 mb-0">Add your Job Title</p>
        <p class="section__item-subtit">
          This information helps us tailor our communications and services to better meet your needs
        </p>
      </div>
      <div class="col-7">
        <xen-input
          [label]="'Job title'"
          [formControlName]="'jobTitle'"
          [required]="true"
          [type]="'text'"
          [placeholder]="'e.g. CEO'"
          [size]="'medium'"
          [validation]="true"
          [validation_status]="getValidationStatus('jobTitle', true)"
          [feedback]="
            professionalDetailsForm.get('jobTitle').dirty
              ? $safeNavigationMigration(professionalDetailsForm.get('jobTitle').errors?.errorMsg)
              : ''
          "
        ></xen-input>
      </div>
    </div>
  </div>
  <div class="row mb-5">
    <div class="d-flex justify-content-end gap-2">
      @if (isEditing) {
        <xen-btn
          class="d-block"
          [type]="'flat'"
          [size]="'large'"
          label="Cancel"
          [icon]="false"
          [icon_placement]="'right'"
          [skin]="'gray'"
          [loading]="isLoading"
          (clicked)="cancelChanges()"
        ></xen-btn>
      }
      <xen-btn
        class="d-block"
        [type]="'primary'"
        [size]="'large'"
        [label]="buttonName"
        [icon]="true"
        [icon_placement]="'right'"
        [icon_snippet]="'far fa-angle-right'"
        [skin]="'blue'"
        [disabled]="isButtonDisabled()"
        [loading]="isLoading"
        (clicked)="submitDetailsForm()"
      ></xen-btn>
    </div>
  </div>
</div>
